// src/components/NavItem.js
import React from 'react';
import { Link } from 'react-router-dom';
import './NavItem.css'; // Enhanced styles

const NavItem = ({ title, addLink, manageLink }) => {
  return (
    <div className='nav-item'>
      <div className='nav-item__header'>
        <h3 className='nav-item__title'>{title}</h3>
      </div>
      <div className='nav-item__actions'>
        <Link to={addLink} className='nav-item__button add-button'>Ajouter</Link>
        <Link to={manageLink} className='nav-item__button manage-button'>Gérer</Link>
      </div>
    </div>
  );
};

export default NavItem;
